export default {
  title: "선용품 웹수발주",
  version: "v1.8.0",
};
